import React from "react";
import colors from "../../../utils/colors";

interface TableRow {
  [key: string]: string;
}

interface TableProps {
  data: TableRow[];
  columns: string[];
  renderCell?: (
    cellData: string,
    row: TableRow,
    column: string
  ) => React.ReactNode;
  displayActions: (column: string, id: string) => JSX.Element | undefined;
  isClickable?: boolean;
  handleClick?: (id: string) => void;
  onClickDots?: (column: string, id: string) => void;
  tableReference?: string;
}

const Table = ({
  columns,
  data,
  renderCell,
  displayActions,
  isClickable,
  handleClick,
  tableReference = "patient",
}: TableProps) => {
  return (
    <div className="w-full overflow-x-auto">
      <table className="min-w-[800px] w-full text-xs border-separate border-spacing-x-0 border-spacing-y-[2px]">
        <thead
          style={{
            backgroundColor: colors.lightGrey,
            color: colors.placeholderColor,
            fontWeight: "200",
          }}
          className="shadow-md whitespace-nowrap"
        >
          <tr>
            {columns.map((column) => (
              <th className="p-4 text-sm font-light text-left" key={column}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data?.map((row) => {
            const keyField =
              tableReference === "appointment"
                ? "Appointment ID"
                : "Patient ID";

            return (
              <tr
                key={row[keyField]}
                className={`bg-white shadow-md ${
                  isClickable ? "cursor-pointer" : ""
                }`}
              >
                {columns.map((column) => (
                  <td
                    key={column}
                    className="p-4 whitespace-nowrap"
                    onClick={() => {
                      if (column !== "Actions") {
                        handleClick && handleClick(row[keyField]);
                      }
                    }}
                  >
                    {renderCell
                      ? renderCell(row[column], row, column)
                      : row[column]}
                    {displayActions(column, row[keyField])}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
